import React from 'react'
import type { GetStaticProps, InferGetStaticPropsType, NextPage } from 'next'
import Head from 'next/head'

import { SitemapPage, SitemapSection } from 'components/Sitemap'
import ResponsivePageLayout from 'components/Layout/ResponsivePageLayout'

import { browseLocationLandingIndex } from 'utils/locationLanding/api/fetching/browseLocationLandingIndex'
import { getSitemapLinks } from 'utils/sitemap'
import { fetchFooterData, fetchGlobalOptionsData } from 'utils/staticData'

export const getStaticProps: GetStaticProps = async () => {
  const footerData = await fetchFooterData()
  const globalOptionsData = await fetchGlobalOptionsData()

  const pageFooterData = {
    menus: footerData,
    options: globalOptionsData.acf.global_footer_group,
  }

  const sitemapLocationData = await browseLocationLandingIndex({
    returnType: 'SitemapLocationData',
    attributesToRetrieve: ['objectID', 'countryData', 'stateData'],
    batchMapCb: (hit) => hit,
  })

  return {
    props: {
      footerData: pageFooterData,
      sitemapLinks: getSitemapLinks(sitemapLocationData),
    },
  }
}

const LINK_SECTIONS = [
  {
    header: 'USA',
    key: 'us',
  },
]

const SitemapIndex: NextPage<
  InferGetStaticPropsType<typeof getStaticProps>
> = ({ footerData, sitemapLinks }) => {
  const meta = {
    title: 'Vacation Rental Destinations | Evolve Sitemap',
    description:
      'Explore a list of links to all of our vacation rental destinations',
  }
  const canonicalUrl = `${process.env.NEXT_PUBLIC_ORIGIN}/sitemap`

  return (
    <>
      <Head>
        <title>{meta.title}</title>
        <meta content={meta.title} property="og:title" />
        <meta content={meta.title} name="twitter:title" />
        <meta content={meta.description} name="description" />
        <meta content={meta.description} property="og:description" />
        <link href={canonicalUrl} rel="canonical" />
      </Head>
      <ResponsivePageLayout
        footerData={footerData}
        headerData={{
          hideSearchBox: true,
        }}
      >
        <SitemapPage title="Vacation Rental Destinations">
          {LINK_SECTIONS.map(({ header, key }) => (
            <SitemapSection
              heading={header}
              isIndex
              key={`${key}-section`}
              links={sitemapLinks[key]}
            />
          ))}
        </SitemapPage>
      </ResponsivePageLayout>
    </>
  )
}

export default SitemapIndex
